import React from 'react';
import { connectToJSContext } from "../utils";
import { RecaptchaLoader } from "./RecaptchaLoader";

class Recaptcha extends React.Component {

    constructor(props) {
        super(props);
        this.id = Math.floor(Math.random() * 1000);
    }

    componentDidMount() {
        this.loadCaptcha();
    }

    loadCaptcha = () => {
        const captcha = document.getElementById(this.id);
        RecaptchaLoader.load().then(() => {
            window.grecaptcha.render(captcha, {
                sitekey: this.props.siteKey,
                callback: this.props.recaptchaIsValidHandler,
                'expired-callback': this.props.recaptchaIsInvalidHandler
            });
        });
    };

    render() {
        const hasError = this.props.recaptcha.hasTouched && !this.props.recaptcha.isValid;
        const errorMessage = hasError ?
            <p aria-live="polite" className="error-message error-message-name">{this.props.errorMessage}</p> :
            null;
        const recaptchaClassName = hasError ?
            'form-group validation-error g-recaptcha-wrapper' : 'form-group g-recaptcha-wrapper';

        return (
            <div className="form-group-input-wrapper">
                <div className={recaptchaClassName}>
                    <div id={this.id} className="g-recaptcha"/>
                    {errorMessage}
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        errorMessage: state.theme_data.contact_form.messages.error.recapcha_error
    };
};

export default connectToJSContext(mapStateToProps)(Recaptcha);



// WEBPACK FOOTER //
// ./components/recaptcha/Recaptcha.js